import type { FC } from 'react';
import { Alert } from 'reactstrap';
import { AutoboxingUnboxingWrapper } from './AutoboxingUnboxing.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface AutoboxingUnboxingProps { }

const AutoboxingUnboxing: FC<AutoboxingUnboxingProps> = () => (
   <AutoboxingUnboxingWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Autoboxing &amp; Unboxing</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">Autoboxing and Unboxing is a feature that is achieved with the help of Wrapper Classes. The wrapper class provides the mechanism to convert primitive data types into objects and objects into primitive data types.</p>
         <h4 className="text-align-justify"><strong>Autoboxing </strong></h4>
         <ul className="text-align-justify">
            <li>This feature convert primitives into objects.</li>
            <li>In other words, it allows the automatic conversion of primitive data types into their corresponding wrapper class.</li>
         </ul>

         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '//Converting int into Integer explicitly\n'+
               'int num = 10;\n'+
               'Integer i = Integer.valueOf(num);\n'+
               '\n'+
               '//To achieve it using autoboxing\n'+
               'int num = 10;\n'+
               'Integer i = num;'
            }
         </SyntaxHighlighter>

         <br/>
         <h4 className="text-align-justify"><strong>Unboxing </strong></h4>
         <ul className="text-align-justify">
            <li>This feature converts objects into primitives.</li>
            <li>In other words, it allows the automatic conversion of wrapper type into its corresponding primitive type.</li>
         </ul>

         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '//To convert Integer to int explicitly\n'+
               'Integer i = new Integer(3);\n'+
               'int num = i.intValue();\n'+
               '\n'+
               '//To achieve it using unboxing\n'+
               'Integer i = new Integer(3);\n'+
               'int num = i;'
            }
         </SyntaxHighlighter>

         <br/>
         <Alert>
            <p className="text-align-center">
               <a href="/type-casting">To know about type casting, click here!</a>
            </p>
         </Alert>
      </div>
   </AutoboxingUnboxingWrapper>
);

export default AutoboxingUnboxing;
